import { Component, HostListener, ViewChild } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { MatSidenav, MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatInputModule } from '@angular/material/input';
import { CommonModule } from '@angular/common';
import { filter } from 'rxjs/operators';
import { LanguageSelector, I18nService } from '../.././../core/i18n';
import { MatDialog } from '@angular/material/dialog';
import { HasRoleDirective } from '../../../core/directives/has-role.directive';
import { Store } from '@ngrx/store';
import { LogoutCommand } from '../../../features/auth/state-management/auth.commands';
import { SciGuaduaIsAllowedDirective } from '@scifamek/guadua';

@Component({
  selector: 'app-navigation',
  imports: [
    SciGuaduaIsAllowedDirective,
    CommonModule,
    MatSidenavModule,
    MatListModule,
    MatIconModule,
    MatButtonModule,
    MatToolbarModule,
    MatExpansionModule,
    MatInputModule,
    LanguageSelector,
    HasRoleDirective
  ],
  templateUrl: './navigation.html',
  styleUrl: './navigation.scss',
})
export class Navigation {
  @ViewChild('sidenav') sidenav!: MatSidenav;
  isMobile = false;
  currentRoute = '';

  constructor(
    private router: Router,
    readonly i18n: I18nService,
    private dialog: MatDialog,
    private store: Store
  ) {
    this.checkScreenSize();
    this.currentRoute = this.router.url;

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        this.currentRoute = event.url;
      });
  }

  @HostListener('window:resize')
  onResize() {
    this.checkScreenSize();
  }

  checkScreenSize() {
    this.isMobile = window.innerWidth < 768;
  }

  navigateTo(route: string) {
    this.dialog.closeAll();
    this.router.navigate([route]);
  }

  closeSidenavIfMobile() {
    if (this.isMobile && this.sidenav) {
      this.sidenav.close();
    }
  }

  isActive(route: string): boolean {
    return this.currentRoute === route;
  }

  logout() {
    this.store.dispatch(LogoutCommand());
  }
}
